import { useState } from "react";
import {
  RiAddLine,
  RiFileTextLine,
  RiEditLine,
  RiDeleteBinLine,
  RiArrowLeftLine,
} from "react-icons/ri";
import { useNavigate } from "react-router-dom";

const InvoiceTemplates = () => {
  const navigate = useNavigate();
  const [templates, setTemplates] = useState([
    {
      id: 1,
      name: "Standard Invoice",
      description: "Basic invoice template for general use",
      lastUsed: "2024-02-15",
      type: "Professional",
    },
    {
      id: 2,
      name: "Detailed Service Invoice",
      description: "Template with detailed service breakdown",
      lastUsed: "2024-02-10",
      type: "Service",
    },
  ]);

  return (
    <div className="max-w-full mx-auto space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <button
            onClick={() => navigate("/billing")}
            className="p-2 hover:bg-gray-100 rounded-lg text-gray-600 transition-colors"
          >
            <RiArrowLeftLine className="w-5 h-5" />
          </button>
          <h1 className="text-3xl font-bold text-gray-900">
            Invoice Templates
          </h1>
        </div>
        <button className="btn btn-primary flex items-center gap-2">
          <RiAddLine className="w-5 h-5" />
          Create Template
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {templates.map((template) => (
          <div
            key={template.id}
            className="card hover:shadow-lg transition-shadow"
          >
            <div className="flex items-start justify-between">
              <div className="flex items-center gap-3">
                <RiFileTextLine className="w-8 h-8 text-primary-600" />
                <div>
                  <h3 className="font-semibold text-lg">{template.name}</h3>
                  <p className="text-sm text-gray-500">{template.type}</p>
                </div>
              </div>
              <div className="flex gap-2">
                <button className="p-2 hover:bg-gray-100 rounded-lg text-gray-600">
                  <RiEditLine className="w-5 h-5" />
                </button>
                <button className="p-2 hover:bg-gray-100 rounded-lg text-gray-600">
                  <RiDeleteBinLine className="w-5 h-5" />
                </button>
              </div>
            </div>
            <p className="text-gray-600 mt-3">{template.description}</p>
            <div className="mt-4 pt-4 border-t">
              <p className="text-sm text-gray-500">
                Last used: {new Date(template.lastUsed).toLocaleDateString()}
              </p>
              <button className="btn btn-secondary w-full mt-3">
                Use Template
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InvoiceTemplates;
